import React, { useEffect, useState } from 'react'
import { request } from 'meinian-package/src/utils'
import Select from 'meinian-package/src/baseComponent/select'

export default ({ value = null, onChange }) => {
  const [option, setOption] = useState([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const result = await request.get('/zhikuan/ins/inspiration/work/platform/pending-mark-users')
    const _result = result.map(item => ({
      label: item.userName,
      value: item.userId,
      ...item
    }))
    setOption(_result)
  }

  return <Select
    trigger="click"
    placeholder="全部"
    data={option}
    value={value}
    ulStyle={{ minWidth: '144px' }}
    container={document.body}
    onChange={(val, itemVal) => onChange(itemVal)}
  />
}
